export default "__VITE_ASSET__BR6aav7___"